module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+DQogIDx0aXRsZT4gc2VsZWN0aW9uIDwvdGl0bGU+DQogIDxnIGlkPSJpY29uIj4NCiAgICA8cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIxLjYiIGZpbGw9IiNhM2EzYTMiLz4NCiAgICA8cG9seWdvbiBwb2ludHM9IjI4LjU3IDExLjQzIDExLjQzIDE4LjMgMTcuMjUgMjEuMjEgMTMuMTggMjUuMjggMTUgMjcuMSAxOC45OCAyMy4xMyAyMS43IDI4LjU3IDI4LjU3IDExLjQzIiBmaWxsPSIjZmZmIi8+DQogIDwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/plano/images/icons/selection_on.svg
// module id = 2632
// module chunks = 0